import template from './body.pug';

export const FinancesTableBodyComponent = {
  template,
  bindings: {
    filter: '<',
    records: '<',
    checkedIds: '<',
    onCheck: '&',
    gridOptions: '<?',
    loading: '<?',
    onFilterChange: '&'
  },
  controller: class FinancesTableBodyComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {}

    applyFilter({ filter, searchId }) {
      this.onFilterChange({
        $event: { filter, searchId }
      });
    }

    checkIds({ checkedIds }) {
      this.onCheck({
        $event: { checkedIds }
      });
    }
  }
};
